"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const get_1 = __importDefault(require("lodash/get"));
require("./expertsList.scss");
const core_1 = require("@material-ui/core");
const expertsSlice_1 = require("../../../../redux/slices/expertsSlice");
const modalsSlice_1 = require("../../../../redux/slices/modalsSlice");
const Autocomplete_1 = __importDefault(require("@material-ui/lab/Autocomplete/Autocomplete"));
require("./expertsList.scss");
const snackBar_1 = __importDefault(require("../modals/snackBar"));
const adminPagination_1 = __importDefault(require("../../../../shared/components/adminPagination/adminPagination"));
const locationOption = data => {
    const states = get_1.default(data, 'states');
    let text = '';
    if (states) {
        if (states.length > 1 && states.length < 51) {
            text = 'Multiple Locations';
        }
        else if (states.length >= 51) {
            text = 'Nationwide';
        }
        else if (states.length) {
            text = states[0].name;
        }
    }
    return text;
};
const tableHead = {
    0: [
        {
            key: "ID",
            value: "id"
        }, {
            key: "Avatar",
            value: "avatar"
        }, {
            key: "Full Name",
            value: "name"
        }, {
            key: "Occupation",
            value: "blocks.occupation"
        }, {
            key: "Company",
            value: "company_name"
        }, {
            key: "Phone",
            value: [
                "phone.mobile",
                "phone.office"
            ]
        }, {
            key: "Fax",
            value: "phone.fax"
        }, {
            key: "Email",
            value: "email"
        }, {
            key: "Location Options",
            value: (data) => locationOption(data)
        }, {
            key: "Status",
            value: "statusString"
        }
    ],
    1: [
        {
            key: "ID",
            value: "id"
        }, {
            key: "Avatar",
            value: "avatar"
        }, {
            key: "Full Name",
            value: "name"
        },
        {
            key: "Service Type",
            value: "mainService.name"
        },
        {
            key: "Company",
            value: "company_name"
        },
        {
            key: "Phone",
            value: "phone.mobile"
        },
        {
            key: "Fax",
            value: "phone.fax"
        },
        {
            key: "Email",
            value: "email"
        },
        {
            key: "Location Options",
            value: (data) => locationOption(data)
        }, {
            key: "Status",
            value: "statusString"
        }
    ]
};
class ExpertsList extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            modalOpen: false,
            selectedExpert: null,
            currentPage: 1,
            count: 0,
            q: '',
            state: null,
            status: null,
            service: null,
            anchorEl: null,
            popoverOpen: false
        };
        this.getExpertsList = (event, page) => {
            const { q, state, status, service } = this.state;
            const { type } = this.props;
            this.props.getExpertsList({
                offset: (page - 1),
                q,
                type,
                state: state ? state.id : null,
                status: status ? status.id : null,
                service: (service && type === 1) ? service.id : null
            });
            this.setState({ currentPage: page });
        };
        // set pagination data object
        this.setPaginationData = () => {
            const { count, visibleCount } = this.props;
            const { currentPage } = this.state;
            const from = currentPage === 1 ? currentPage : (((currentPage - 1) || 1) * visibleCount) + 1;
            let to = currentPage === 1 ? visibleCount : (from + visibleCount) - 1;
            if (to > count) {
                to = count;
            }
            return {
                from,
                to,
                count: Math.ceil(count / visibleCount),
                total: count,
                currentPage,
                pageChange: this.getExpertsList
            };
        };
        this.handleClick = event => {
            this.state.anchorEl
                ? this.setState({ anchorEl: null })
                : this.setState({ anchorEl: event.currentTarget });
        };
    }
    selectExpert(expert) {
        /*this.props.initEditExpert(expert);
        this.setState({selectedExpert: expert, modalOpen: true})*/
        window.location.href = `#/admin-panel?tab=single-expert&uid=${expert.uid}`;
    }
    searchExpert(e) {
        const val = e.target.value;
        const { state, status } = this.state;
        if (val.length >= 3 || !val) {
            this.setState({
                currentPage: 1,
                q: val,
            });
            this.props.getExpertsList({
                offset: 0,
                q: val,
                type: this.props.type,
                state: state ? state.id : null,
                status: status ? status.id : undefined
            });
        }
    }
    async triggerUserStatus(props) {
        var _a;
        const { value, expert } = props;
        const status = value === 'Draft' ? 0 : value === 'Published' ? 1 : null;
        if (status === null) {
            return null;
        }
        const snackBarProps = {
            root: '',
            key: 'snackbar',
        };
        await this.props.initEditExpert(expert);
        await this.props.editExpert({ key: "status", val: status });
        try {
            await this.props.submitEdit();
            this.props.initEditExpert(null);
            this.props.triggerModal(Object.assign(Object.assign({}, snackBarProps), { val: {
                    type: 'success',
                    text: `Expert successfully updated`
                } }));
        }
        catch (e) {
            const msg = ((_a = e === null || e === void 0 ? void 0 : e.data) === null || _a === void 0 ? void 0 : _a.message) || e.toString();
            this.props.triggerModal(Object.assign(Object.assign({}, snackBarProps), { val: {
                    type: 'error',
                    text: msg
                } }));
        }
    }
    get createBtnRender_0() {
        return (react_1.default.createElement(core_1.Link, { className: "v2-btn v2-btn-primary", target: "_blank", href: `#/admin-panel?tab=single-expert&directoryType=0&action=create`, rel: "noopener" }, "Create User"));
    }
    get createBtnRender_1() {
        const options = [{
                id: 0,
                name: 'Company',
                label: 'company'
            }, {
                id: 1,
                name: 'Individual',
                label: 'individual'
            }];
        const open = Boolean(this.state.anchorEl);
        const id = open ? "simple-popper" : undefined;
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(core_1.Button, { className: "v2-btn v2-btn-primary", onClick: event => this.handleClick(event) }, "Create User"),
            react_1.default.createElement(core_1.Popover, { id: id, open: open, anchorEl: this.state.anchorEl, onClose: event => this.handleClick(event), anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center',
                }, transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center',
                } }, options.map(item => react_1.default.createElement(core_1.ListItem, { button: true, key: item.id },
                react_1.default.createElement(core_1.ListItemText, null,
                    react_1.default.createElement(core_1.Link, { target: "_blank", href: `#/admin-panel?tab=single-expert&directoryType=1&serviceType=${item.label}&action=create`, rel: "noopener" }, item.name)))))));
    }
    getTableCell(row, val, key) {
        let cell = (react_1.default.createElement("span", null, get_1.default(row, val.value)));
        if (typeof val.value === "function") {
            cell = val.value(row);
        }
        else if (val.value === "name" || val.value === "company_name") {
            cell = (react_1.default.createElement("a", { className: "as-link", target: "_blank", href: `#/admin-panel?tab=single-expert&uid=${row.uid}&action=edit`, key: key }, get_1.default(row, val.value)));
        }
        else if (Array.isArray(val.value)) {
            cell = val.value.map((v, k) => (react_1.default.createElement(react_1.Fragment, { key: k },
                react_1.default.createElement("span", { key: k }, get_1.default(row, v)))));
        }
        else if (val.value === "statusString") {
            cell = (react_1.default.createElement(core_1.FormControl, { variant: "outlined" },
                react_1.default.createElement(core_1.Select, { className: "status-select", defaultValue: get_1.default(row, val.value) || "", onChange: (event) => {
                        this.triggerUserStatus({ value: event.target.value, expert: row });
                    }, inputProps: {
                        label: "Status",
                        variant: "outlined"
                    } }, ["Draft", "Published"].map((val, key) => react_1.default.createElement(core_1.MenuItem, { key: key, value: val }, val)))));
        }
        else if (val.value === 'ingestionTime') {
            cell = (react_1.default.createElement("span", null, new Date(get_1.default(row, val.value))));
        }
        else if (val.value === 'avatar') {
            cell = react_1.default.createElement(core_1.Avatar, { alt: row === null || row === void 0 ? void 0 : row.name, src: get_1.default(row, val.value) });
        }
        return (react_1.default.createElement(core_1.TableCell, { key: key, className: "admin-cases-nowrap" }, cell));
    }
    get locationOptionRender() {
        const { states } = this.props;
        const mutated = [].concat([{
                name: "Nationwide",
                id: 53
            }, {
                name: "Multiple Locations",
                id: 54
            }], states.slice());
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: "select-label" }, "Location Options"),
            react_1.default.createElement(Autocomplete_1.default, { onChange: (e, v) => {
                    this.setState({ state: v });
                }, className: "location-option-select", freeSolo: true, options: mutated, getOptionLabel: (mutated) => mutated.name, renderInput: (params) => react_1.default.createElement(core_1.TextField, Object.assign({}, params, { label: "Location Options", variant: "outlined" })) })));
    }
    get statusRender() {
        const statuses = [{
                name: "Draft",
                id: 0
            }, {
                name: "Published",
                id: 1
            }];
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: "select-label" }, "Status"),
            react_1.default.createElement(Autocomplete_1.default, { onChange: (e, v) => {
                    this.setState({ status: v });
                }, className: "occupation-select", freeSolo: true, options: statuses, getOptionLabel: (statuses) => statuses.name, renderInput: (params) => (react_1.default.createElement(core_1.TextField, Object.assign({}, params, { label: "Status", variant: "outlined" }))) })));
    }
    get searchBtnRender() {
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(core_1.Button, { className: "v2-btn v2-btn-primary", onClick: () => this.getExpertsList({}, 1) }, " Filter")));
    }
    get servicesRenderer() {
        const { services } = this.props;
        return (react_1.default.createElement("div", null,
            react_1.default.createElement("div", { className: "select-label" }, "Main Service"),
            react_1.default.createElement(Autocomplete_1.default, { onChange: (e, v) => {
                    this.setState({ service: v });
                }, className: "location-option-select", freeSolo: true, options: services, getOptionLabel: (services) => services.name, renderInput: (params) => react_1.default.createElement(core_1.TextField, Object.assign({}, params, { label: "Service", variant: "outlined" })) })));
    }
    get type_0() {
        return (react_1.default.createElement(react_1.Fragment, null,
            this.locationOptionRender,
            this.statusRender,
            this.searchBtnRender));
    }
    get type_1() {
        return (react_1.default.createElement(react_1.Fragment, null,
            this.locationOptionRender,
            this.statusRender,
            this.servicesRenderer,
            this.searchBtnRender));
    }
    render() {
        const { experts, type } = this.props;
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement("div", { className: "row my-10" },
                react_1.default.createElement("div", { className: "filter my-10" },
                    react_1.default.createElement("div", { className: "left-side" }, this[`type_${type}`]),
                    react_1.default.createElement("div", { className: "right-side" }, this[`createBtnRender_${type}`])),
                react_1.default.createElement("div", { className: "search-pagination" },
                    react_1.default.createElement("div", { className: "search-box" },
                        react_1.default.createElement("input", { type: "text", placeholder: "Search", id: "search-expert", onChange: (e) => this.searchExpert(e) })),
                    this.props.count > this.props.visibleCount && react_1.default.createElement(adminPagination_1.default, { data: this.setPaginationData() })),
                react_1.default.createElement(core_1.TableContainer, { className: "clearfix experts-table-container" },
                    react_1.default.createElement(core_1.Table, { "aria-label": "experts table", className: "table admin-panel-table table-history admin-users-table" },
                        react_1.default.createElement(core_1.TableHead, { className: "admin-panel-table-thead" },
                            react_1.default.createElement(core_1.TableRow, null, tableHead[type].map((val, key) => {
                                return (react_1.default.createElement(core_1.TableCell, { key: key }, val.key));
                            }))),
                        react_1.default.createElement(core_1.TableBody, { className: "admin-panel-table-tbody" }, experts.length ? experts.map((row, key) => {
                            return (react_1.default.createElement(core_1.TableRow, { key: key }, tableHead[type].map((val, key) => this.getTableCell(row, val, key))));
                        }) : react_1.default.createElement(core_1.TableRow, null,
                            react_1.default.createElement(core_1.TableCell, null, "No results to show.")))))),
            this.props.count > this.props.visibleCount && react_1.default.createElement(adminPagination_1.default, { data: this.setPaginationData() }),
            react_1.default.createElement(snackBar_1.default, null)));
    }
}
const mapStateToProps = (state) => {
    const { experts, staticData } = state;
    return {
        experts: experts.list || [],
        count: experts.count || 0,
        visibleCount: experts.visibleCount || 0,
        states: staticData.states,
        services: experts.services
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getExpertsList: (data) => dispatch(expertsSlice_1.getExpertsList(data)),
        submitEdit: () => dispatch(expertsSlice_1.submit()),
        initEditExpert: (data) => dispatch(expertsSlice_1.initEditExpert(data)),
        editExpert: (data) => dispatch(expertsSlice_1.editExpert(data)),
        triggerModal: (data) => dispatch(modalsSlice_1.triggerModal(data)),
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ExpertsList);
